import React from 'react';
import './App.css';
import Body from './components/body/Body'
import Footer from './components/footer/Footer'
import Navi from './components/header/Navi'

function App() {
  return (
    <>
      <Navi />
      <Body />
      <Footer />
    </>
  );
}

export default App;
